import { useEffect } from 'react';
import { useUserStore } from '../store/useUserStore';
import { useCustomer } from './useCustomer';
import { useCustomerAddresses } from './useCustomer';

// Hook para sincronizar datos de PrestaShop con el store local
export const useUserSync = () => {
  const { 
    isLogged, 
    profile, 
    customerId, 
    setProfile, 
    setCustomerId, 
    clearUserData 
  } = useUserStore();

  // Obtener datos del cliente desde PrestaShop
  const { 
    data: customerData, 
    isLoading: isLoadingCustomer,
    error: customerError 
  } = useCustomer(profile?.email || '');

  // Obtener direcciones del cliente desde PrestaShop
  const { 
    data: customerAddresses,
    isLoading: isLoadingAddresses,
    refetch: refetchAddresses
  } = useCustomerAddresses(customerData?.id || 0);

  // Sincronizar datos cuando se loguee el usuario
  useEffect(() => {
    if (isLogged && profile?.email && customerData) {
      // Actualizar el perfil con los datos de PrestaShop
      const updatedProfile = {
        ...profile,
        firstName: customerData.firstname || profile.firstName,
        lastName: customerData.lastname || profile.lastName,
        email: customerData.email || profile.email,
        id: customerData.id,
        active: customerData.active,
        // Mantener el provider original
        provider: profile.provider
      };

      setProfile(updatedProfile);
      setCustomerId(customerData.id);
    }
  }, [isLogged, profile?.email, customerData, setProfile, setCustomerId]);

  // Limpiar datos cuando se desloguee
  useEffect(() => {
    if (!isLogged) {
      clearUserData();
    }
  }, [isLogged, clearUserData]);

  return {
    customerData,
    customerAddresses,
    isLoadingCustomer,
    isLoadingAddresses,
    customerError,
    refetchAddresses,
    isSynced: !isLoadingCustomer && !!customerData
  };
};
